module.exports = __webpack_public_path__ + "static/media/closeIcon.9cb3ddf4.svg";